<app-feature-hero
    title="Fixed Asset Management Solution"
    description="Maximize the ROI of critical assets with Infraon’s <br /> Fixed Asset Management solution."
    image="/assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-header-bg.webp"
    imageAlt="Fixed Asset Management Hero Image"
></app-feature-hero>

<app-feature-row
    headingLevel="h2"
    heading="What Is Fixed Asset Management?"
    [paragraphs]="whatIsParagraphs"
    image="/assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-feature-img-1.webp"
    imageAlt="hardware asset management"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Infraon’s Fixed Asset Management Solution"
    [paragraphs]="solutionParagraphs"
    image="/assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-feature-img-2.webp"
    imageAlt="Asset performance"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<section class="section-spacing container">
    <div
        class="ai-based-itsm depreciation-calculator case-study d-flex align-items-center justify-content-between bg-grey">
        <div>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                Struggling to Measure Asset <br />
                Depreciation?
            </h2>
            <h3 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                Try Our Calculator!
            </h3>
            <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">
                Enhance your financial planning with accurate asset depreciation
                <br />
                measurements – make informed and strategic decisions every time.
            </p>

            <a routerLink="/free-tools/asset-depreciation-calculator/" class="crmform-button">
                <span style="color: #0d51d9 !important; font-weight: 700">Calculate</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
                    <path
                        d="M2.34766 0.9375L8.78125 7.65234C8.92188 7.82812 9.02734 8.03906 9.02734 8.25C9.02734 8.46094 8.92188 8.67188 8.78125 8.8125L2.34766 15.5273C2.03125 15.8789 1.46875 15.8789 1.15234 15.5625C0.800781 15.2461 0.800781 14.7188 1.11719 14.3672L7.02344 8.21484L1.11719 2.09766C0.800781 1.78125 0.800781 1.21875 1.15234 0.902344C1.46875 0.585938 2.03125 0.585938 2.34766 0.9375Z"
                        fill="#1A5AD9" />
                </svg>
            </a>
        </div>
    </div>
</section>

<section class="key-features container section-spacing">
    <h2 class="section-title p-lr-60 p-b-60">
        Key Features of Infraon’s <br />
        Fixed Asset Management
    </h2>

    <div class="row mx-0 feature-box">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="25" viewBox="0 0 33 25" fill="none">
                    <rect x="4" y="3" width="26" height="19" fill="#A8C1F1" />
                    <path
                        d="M32.25 0.25V24.75H0.75V0.25H32.25ZM8.625 5.5H6V19.5H8.625V5.5ZM10.375 5.5V19.5H12.125V5.5H10.375ZM16.5 5.5H13.875V19.5H16.5V5.5ZM20 5.5V19.5H22.625V5.5H20ZM27 5.5H25.25V19.5H27V5.5Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Fixed Asset Lifecycle Management
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Ensure all fixed assets are audit-ready by digitizing records.
                    Monitor and quickly retrieve any asset information.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="28" viewBox="0 0 35 28" fill="none">
                    <path d="M3.5 12.75V23.25H0V12.75H3.5ZM35 12.75V23.25H31.5V12.75H35Z" fill="#A8C1F1" />
                    <path
                        d="M19 0V1.75V5.25H29.5V28H5V5.25H15.5V1.75V0H19ZM14.1875 14C14.1875 12.7969 13.2031 11.8125 12 11.8125C10.7422 11.8125 9.8125 12.7969 9.8125 14C9.8125 15.2578 10.7422 16.1875 12 16.1875C13.2031 16.1875 14.1875 15.2578 14.1875 14ZM22.5 16.1875C23.7031 16.1875 24.6875 15.2578 24.6875 14C24.6875 12.7969 23.7031 11.8125 22.5 11.8125C21.2422 11.8125 20.3125 12.7969 20.3125 14C20.3125 15.2578 21.2422 16.1875 22.5 16.1875Z"
                        fill="#084CD4" />
                    <rect x="10" y="21" width="14" height="2" rx="1" fill="#A8C0F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Automated Fixed Asset Onboarding
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Automate approval workflows for onboarding new fixed assets.
                    Accelerate the speed at which assets are utilized.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="25" viewBox="0 0 32 25" fill="none">
                    <path
                        d="M5.44531 4.67969C8.01562 2.27344 11.5703 0.25 16 0.25C20.375 0.25 23.9297 2.27344 26.5 4.67969C29.0703 7.03125 30.7656 9.875 31.5859 11.8438C31.75 12.2812 31.75 12.7734 31.5859 13.2109C30.7656 15.125 29.0703 17.9688 26.5 20.375C23.9297 22.7812 20.375 24.75 16 24.75C11.5703 24.75 8.01562 22.7812 5.44531 20.375C2.875 17.9688 1.17969 15.125 0.359375 13.2109C0.195312 12.7734 0.195312 12.2812 0.359375 11.8438C1.17969 9.875 2.875 7.03125 5.44531 4.67969Z"
                        fill="#084CD4" />
                    <path
                        d="M9 12C9 8.17188 12.1172 5 16 5C19.8281 5 23 8.17188 23 12C23 15.8828 19.8281 19 16 19C12.1172 19 9 15.8828 9 12ZM16 16.375C18.4062 16.375 20.375 14.4609 20.375 12C20.375 9.59375 18.4062 7.625 16 7.625C15.9453 7.625 15.8906 7.625 15.8359 7.625C15.9453 7.95312 16 8.22656 16 8.5C16 10.4688 14.4141 12 12.5 12C12.1719 12 11.8984 12 11.625 11.8906C11.625 11.9453 11.625 12 11.625 12C11.625 14.4609 13.5391 16.375 16 16.375Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Fixed Asset Visibility
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Get a complete view of your asset availability, performance, and
                    maintenance. Use a single source of truth about the asset
                    ecosystem.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path
                        d="M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5Z"
                        fill="#A8C0F1" />
                    <path
                        d="M3.375 0.25H11.5234C12.4531 0.25 13.3281 0.632812 13.9844 1.28906L23.6094 10.9141C24.9766 12.2812 24.9766 14.5234 23.6094 15.8906L16.3359 23.1641C14.9688 24.5312 12.7266 24.5312 11.3594 23.1641L1.73438 13.5391C1.07812 12.8828 0.75 12.0078 0.75 11.0781V2.875C0.75 1.45312 1.89844 0.25 3.375 0.25ZM6.875 8.125C7.80469 8.125 8.625 7.35938 8.625 6.375C8.625 5.44531 7.80469 4.625 6.875 4.625C5.89062 4.625 5.125 5.44531 5.125 6.375C5.125 7.35938 5.89062 8.125 6.875 8.125Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Fixed Asset Tagging
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Save time and money by tagging assets with barcoding, RFID, or
                    GPS. Reduce manual inventory with reconciliation workflows.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 25 30" fill="none">
                    <path
                        d="M14.4609 28.5156C13.8047 29.1719 12.9297 29.5 12 29.5C11.0703 29.5 10.1406 29.1719 9.48438 28.5156C8.82812 27.8594 8.5 26.9297 8.5 26H12H15.5C15.5 26.9297 15.1172 27.8594 14.4609 28.5156Z"
                        fill="#A8C1F1" />
                    <path
                        d="M12.2871 0C13.2168 0 14.0371 0.820312 14.0371 1.75V2.84375C18.0293 3.60938 21.0371 7.16406 21.0371 11.375V12.4141C21.0371 14.9844 21.9668 17.5 23.6621 19.4141L24.0449 19.8516C24.5371 20.3984 24.6465 21.1094 24.373 21.7656C24.0996 22.3672 23.4434 22.75 22.7871 22.75H1.78711C1.07617 22.75 0.419922 22.3672 0.146484 21.7656C-0.126953 21.1094 -0.0175781 20.3984 0.474609 19.8516L0.857422 19.4141C2.55273 17.5 3.53711 14.9844 3.53711 12.4141V11.375C3.53711 7.16406 6.54492 3.60938 10.5371 2.84375V1.75C10.5371 0.820312 11.3027 0 12.2871 0Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Fixed Asset Standards
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Stay updated with the latest asset accounting regulations. Ensure
                    enterprise-wide compliance with ease.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="28" viewBox="0 0 21 28" fill="none">
                    <path d="M0 0H12.25V8.75H21V28H0V0Z" fill="#084CD4" />
                    <path d="M21 7H14V0L21 7Z" fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Fixed Asset Reporting
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Generate custom reports to unearth insights about assets. Make
                    better asset management and investment decisions.
                </p>
            </div>
        </div>
    </div>
</section>

<app-feature-row
    headingLevel="h2"
    heading="Other Features of Infraon’s Fixed Asset Management"
    listStyle="check"
    checkIconSize="lg"
    [listItems]="otherFeaturesItems"
    image="/assets/img/feature-pages/infraon-assets/fixed-asset/infinity-feature-image-12-01.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<section class="section-spacing container">
    <div class="ai-based-itsm ebook d-flex align-items-center justify-content-between primary-bg position-relative">
        <div>
            <small data-aos="fade-up" data-aos-delay="100">EBOOK</small>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                The Future of Asset Management: <br />
                Insights for 2024 and Beyond
            </h2>
            <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">
                Learn about the emerging trends in IT asset management and how they
                <br />
                can help secure your organization's success.
            </p>

            <a [routerLink]="['/resources/', 'ebook', 'future-of-itam-2026']" class="crmform-button">
                <span class="me-1">Download our e-book</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path
                        d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
                        fill="#0D51D9" />
                </svg>
            </a>
        </div>
        <img loading="lazy" src="/assets/img/feature-pages/asset-management-ebook.webp"
            class="asset-mmanagement-ebook m-d-none" alt="asset mmanagement ebook" />
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">
        How Infraon Helps Manage the <br />
        Fixed Asset Management Lifecycle
    </h2>

<app-feature-row
    headingLevel="h3"
    heading="Acquisition"
    [paragraphs]="acquisitionParagraph"
    image="/assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-feature-img-1-01.webp"
    imageAlt="Asset Acquisition Chart"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Commissioning"
    [paragraphs]="commissioningParagraph"
    image="/assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-feature-img-3.webp"
    imageAlt="IT Asset Dashboard"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Utilization"
    [paragraphs]="utilizationParagraph"
    image="assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-feature-img-2-01.svg"
    imageAlt="Asset Monitoring"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Maintenance"
    [paragraphs]="maintenanceParagraph"
    image="assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-feature-img-1-01.webp"
    imageAlt="maintenance chart"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Disposal"
    [paragraphs]="disposalParagraph"
    image="/assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-feature-img-4.webp"
    imageAlt="IT Asset Disposal"
    imagePosition="right"
></app-feature-row>
</section>

<section class="section-spacing container">
    <div class="ai-based-itsm case-study d-flex align-items-center justify-content-between bg-grey">
        <div>
            <small data-aos="fade-up" data-aos-delay="100">CASE STUDY</small>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                Helping a Top IT Consulting Company Improve Asset Management
            </h2>
            <div class="case-study-pointers">
                <div>
                    <span></span>
                    <span>Asset efficiency increased by 75%</span>
                </div>
                <div>
                    <span></span>
                    <span>Asset spend reduced by 50%-75%</span>
                </div>
                <div>
                    <span></span>
                    <span>Asset compliance improved by 75%</span>
                </div>
            </div>

            <a [routerLink]="['/resources/', 'case-studies', 'tcs-passport-seva-project']" class="crmform-button" >
                <span style="color: #0d51d9 !important; font-weight: 700">Download Case-study</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path
                        d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
                        fill="#0D51D9" />
                </svg>
            </a>
        </div>
        <div>
            <img loading="lazy" src="/assets/img/feature-pages/case-study-illustration.webp"
                class="case-study-illustration m-d-none" alt="Case Study Illurtation" />
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation
                    (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our
                    customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<app-feature-row
    headingLevel="h2"
    heading="Best Practices for Fixed Asset Management"
    [paragraphs]="bestPracticesParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="bestPracticesItems"
    image="/assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-feature-img-5.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Benefits of Fixed Asset Management"
    [paragraphs]="benefitsParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="benefitsItems"
    image="/assets/img/feature-pages/infraon-assets/fixed-asset/fixed-asset-feature-img-6.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none"
    imagePosition="right"
></app-feature-row>

<section class="section-spacing primary-bg trial-now">
    <div class="container">
        <h2 class="section-title text-center text-white"><span class="text-lowercase">How about a free trial with NO
                credit card required?</span></h2>

        <div class="d-flex justify-content-center">
            <a routerLink="/it-asset-management/prices/assets-pricing" class="secondary-button bg-white">Start now</a>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/it-assets-management-solutions">
                <div class="backlink-container bg-white px-5 py-4 h-100">
                    <p class="section-title-s text-start">IT asset management</p>
                    <p class="section-paragraph-s text-start">
                        Infraon IT Asset Lifecycle Management offers a centralized,
                        low-code platform to optimize your IT asset usage. Make smart
                        purchasing...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/software-assets-management-solutions">
                <div class="backlink-container bg-white px-5 py-4 h-100">
                    <p class="section-title-s text-start">
                        Software asset management
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon IT Asset Lifecycle Management offers a centralized,
                        low-code platform to optimize your IT asset usage. Make smart
                        purchasing...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/software-license-management">
                <div class="backlink-container bg-white px-5 py-4 h-100">
                    <p class="section-title-s text-start">
                        Software Licensing management
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon Assets helps you manage the lifecycles of fixed assets
                        like PCs, laptops, furniture, storage devices, etc., with a
                        360-degree view...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>